export default __webpack_public_path__ + "static/media/logo_row.ff2ec6e2.png";